import styles from '@styles/AdminPanel.module.css'
import { es } from 'date-fns/locale'
import PropTypes from 'prop-types'
import { format } from 'date-fns'

const AppointmentsSection = ({ appointments, filterItems, handleAppointmentStatus, deleteAppointment }) => {
  const renderAppointments = type => {
    const filteredAppointments = filterItems(appointments.filter((app) => app.type === type))
    return (
      <table className={styles.appointmentsTable}>
        <thead>
          <tr>
            <th>Fecha</th>
            <th>Hora</th>
            <th>Nombre</th>
            <th>Teléfono</th>
            <th>Estado</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {filteredAppointments.map(appointment => (
            <tr key={`${appointment.id}-${appointment.date}`}>
              <td>{format(appointment.date, 'dd/MM/yyyy', { locale: es })}</td>
              <td>{appointment.time}</td>
              <td>{appointment.name}</td>
              <td>{appointment.phone}</td>
              <td>{appointment.status}</td>
              <td>
              <button
                  onClick={() => handleAppointmentStatus(appointment.name, appointment.id, "Confirmado")}
                  className={`${styles.confirmButton} ${appointment.status === "Confirmado" ? styles.active : ""}`}
                  disabled={appointment.status === "Confirmado" || appointment.status === "Cancelado"}
                >
                  Confirmar
                </button>
                <button
                  onClick={() => handleAppointmentStatus(appointment.name, appointment.id, "Cancelado")}
                  className={`${styles.cancelButton} ${appointment.status === "Cancelado" ? styles.active : ""}`}
                  disabled={appointment.status === "Confirmado" || appointment.status === "Cancelado"}
                >
                  Cancelar
                </button>
                <button
                  onClick={() => deleteAppointment(appointment.id, appointment.userId)}
                  className={styles.deleteButton}
                >
                  Eliminar
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  }

  return (
    <div className={styles.appointmentsSection}>
      <h2>Citas en Óptica</h2>
      {renderAppointments('optica')}
      <h2>Citas a Domicilio</h2>
      {renderAppointments('domicilio')}
    </div>
  )
}

AppointmentsSection.propTypes = {
  darkMode: PropTypes.bool,
  appointments: PropTypes.array.isRequired,
  filterItems: PropTypes.func.isRequired,
  handleAppointmentStatus: PropTypes.func.isRequired,
  deleteAppointment: PropTypes.func.isRequired
}

export default AppointmentsSection
